
import React, { useState } from 'react';
import './policies.css';

function Faqs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'How do I place a laundry order?',
      answer:
        'You can place an order through our website or mobile platform by selecting the required service, scheduling pickup, and confirming your booking.'
    },
    {
      question: 'What areas do you provide service in?',
      answer:
        'Our pickup and delivery services are available in selected service areas. Please enter your location during checkout to confirm availability.'
    },
    {
      question: 'What are your pickup and delivery timings?',
      answer:
        'Pickup and delivery timings may vary by location and service availability. Available time slots will be shown during booking.'
    },
    {
      question: 'How long does the laundry process take?',
      answer:
        'Standard turnaround time depends on the selected service. Estimated delivery timelines are displayed when placing the order.'
    },
    {
      question: 'What laundry services do you offer?',
      answer:
        'We offer services such as washing, ironing, dry cleaning, folding, and special garment care depending on availability.'
    },
    {
      question: 'How are laundry charges calculated?',
      answer:
        'Charges are based on the selected service type, quantity, garment category, or weight, as applicable.'
    },
    {
      question: 'Can I reschedule or cancel my order?',
      answer:
        'Yes, orders may be rescheduled or cancelled before processing begins, subject to our cancellation policy.'
    },
    {
      question: 'What happens if an item is missing or damaged?',
      answer:
        'Please contact customer support immediately. Claims will be reviewed according to our service policies.'
    },
    {
      question: 'Which payment methods do you accept?',
      answer:
        'We accept available online payment methods and other payment options displayed during checkout.'
    },
    {
      question: 'Do you clean delicate or premium garments?',
      answer:
        'Yes, special care services may be available for delicate fabrics and premium garments.'
    },
    {
      question: 'Can I track my order status?',
      answer:
        'Customers can view order updates and service progress through their account or notifications.'
    },
    {
      question: 'How can I contact customer support?',
      answer:
        'You can contact our support team through the contact details provided on our website or app.'
    }
  ];

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Frequently Asked Questions (FAQs)</h1>

        <p className="last-updated">
          Last Updated: January 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            Find answers to the most commonly asked questions about our
            laundry services, pickup & delivery process, payments,
            cancellations, and more.
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${
                activeIndex === index ? 'active' : ''
              }`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFaq(index)}
              >
                <span>{faq.question}</span>

                <i
                  className={`fas ${
                    activeIndex === index
                      ? 'fa-minus'
                      : 'fa-plus'
                  }`}
                ></i>
              </button>

              {activeIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Faqs;

